import constants from "../constants";
import errorMessageFilter from "../filters/errorMessageFilter";

export default {

  getTypeLabel(type) {
    switch (type) {
      case constants.RANKING_REASON.TYPE.CONGDIEM:
        return errorMessageFilter({
          errorCode: "rankingReason.type.congDiem"
        });
      case constants.RANKING_REASON.TYPE.TRUDIEM:
        return errorMessageFilter({
          errorCode: "rankingReason.type.truDiem"
        });
      default:
        return "-";
    }
  },

  getScoreTypeLabel(type) {
    switch (type) {
      case constants.RANKING_REASON.SCORE_TYPE.CHUYENMON:
        return errorMessageFilter({
          errorCode: "rankingReason.scoreType.chuyenMon"
        });
      case constants.RANKING_REASON.SCORE_TYPE.NGUYENTAC:
        return errorMessageFilter({
          errorCode: "rankingReason.scoreType.nguyenTac"
        });
      default:
        return "-";
    }
  },

  initTypeOptions() {
    return [
      {
        value: constants.RANKING_REASON.TYPE.CONGDIEM,
        label: this.getTypeLabel(
          constants.RANKING_REASON.TYPE.CONGDIEM
        )
      },
      {
        value: constants.RANKING_REASON.TYPE.TRUDIEM,
        label: this.getTypeLabel(
          constants.RANKING_REASON.TYPE.TRUDIEM
        )
      }
    ]
  },

  initScoreTypeOptions() {
    return [
      {
        value: constants.RANKING_REASON.SCORE_TYPE.CHUYENMON,
        label: this.getScoreTypeLabel(
          constants.RANKING_REASON.SCORE_TYPE.CHUYENMON
        )
      },
      {
        value: constants.RANKING_REASON.SCORE_TYPE.NGUYENTAC,
        label: this.getScoreTypeLabel(
          constants.RANKING_REASON.SCORE_TYPE.NGUYENTAC
        )
      }
    ];
  }
}



// WEBPACK FOOTER //
// ./src/services/rankingUtils.js